// extracted by mini-css-extract-plugin
export default {"budgetsOverviewDiv":"Budgets_budgetsOverviewDiv__9ALmY","monthHeading":"Budgets_monthHeading__JFhPu"};